const asyncActionType = type => ({
    pending: `${type}_PENDING`,
    success: `${type}_SUCCESS`,
    error: `${type}_ERROR`
  });

  export const INITIATE_APPLICATION = asyncActionType('aerosimple/settings/INITIATE_APPLICATION');
  export const FETCH_APPLICATIONS = asyncActionType('aerosimple/settings/FETCH_APPLICATIONS');
  export const GET_SCHEMA = asyncActionType('aerosimple/settings/GET_SCHEMA');
  export const UPDATE_SCHEMA = asyncActionType('aerosimple/settings/UPDATE_SCHEMA');
  export const LOGIN_USER = asyncActionType('aerosimple/settings/LOGIN_USER');
  export const VALIDATE_USER = asyncActionType('aerosimple/settings/VALIDATE_USER');
  export const SIGNATORY_REVIEW = asyncActionType('aerosimple/settings/SIGNATORY_REVIEW');
  export const GET_APPLICATION = asyncActionType('aerosimple/settings/GET_APPLICATION');
  export const FETCH_REVIEWED_APPLICATIONS = asyncActionType('aerosimple/settings/FETCH_REVIEWED_APPLICATIONS');
  export const CLEAR_APPLICATION_DETAILS = 'aerosimple/settings/CLEAR_APPLICATION_DETAILS';
  export const GET_ACCESSAREAS = asyncActionType('aerosimple/settings/GET_ACCESSAREAS');
  export const BADGE_REAPPLY = asyncActionType('aerosimple/settings/BADGE_REAPPLY');
  export const INITIATE_BADGE_DELETE = asyncActionType('aerosimple/settings/INITIATE_BADGE_DELETE');
  export const REJECT_BADGE = asyncActionType('aerosimple/settings/REJECT_BADGE');
  export const RENEWAL_APPLICATION = asyncActionType('aerosimple/settings/RENEWAL_APPLICATION');
  export const EDIT_APPLICATION = asyncActionType('aerosimple/settings/EDIT_APPLICATION');
